export const applicationVersion = valueOrDefault('{{APPLICATION_VERSION}}', 'dev') // replaced in CI
export const applicationDate = valueOrDefault('{{APPLICATION_DATE}}', new Date().toISOString().substr(0, 10)) // replaced in CI

function valueOrDefault (value, defaultValue) {
  return value.startsWith('{{') ? defaultValue : value
}
